import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { CardModule } from "primeng/card";
import { BackendInfoService } from "../../_services/backend-info.service";
import { BackendInfo } from "../../../../modules/lipidcompass-backend-client/model/backendInfo";
import { GitShortHashPipe } from "../../_pipes/git-short-hash.pipe";
import { catchError, of } from "rxjs";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"],
  standalone: true,
  imports: [CardModule, CommonModule, GitShortHashPipe]
})
export class FooterComponent {
  private backendInfoService = inject(BackendInfoService);

  copyrightDate: Date = new Date();

  // Resolved as a signal so Angular owns change-detection timing; assigning
  // this in an ngOnInit subscribe previously raised NG0100 in dev mode.
  backendInfo = toSignal(
    this.backendInfoService.getBackendInfo().pipe(
      catchError(error => {
        console.error("Failed to load backend info:", error);
        return of(null);
      })
    ),
    { initialValue: null }
  );
}
